import { forwardRef, ReactNode, HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface TuiPanelProps extends HTMLAttributes<HTMLDivElement> {
  label?: string;
  children: ReactNode;
  className?: string;
  innerClassName?: string;
  right?: ReactNode;
}

/**
 * Bordered "TUI box" with an optional floating top-left label and
 * top-right metadata slot — the visual primitive the whole platform uses.
 */
export const TuiPanel = forwardRef<HTMLDivElement, TuiPanelProps>(
  ({ label, children, className, innerClassName, right, ...rest }, ref) => {
    return (
      <div ref={ref} className={cn("tui-panel", className)} {...rest}>
        {label && <span className="tui-panel-label">{label}</span>}
        {right && (
          <span className="absolute -top-[9px] right-3 px-2 bg-background text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            {right}
          </span>
        )}
        <div className={cn("p-4 md:p-5", innerClassName)}>{children}</div>
      </div>
    );
  },
);
TuiPanel.displayName = "TuiPanel";
